import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import Landing from "@/pages/Landing";
import Booking from "@/pages/Booking";
import { FreeConfirmed } from "@/pages/PaymentResult";
import { PrivacyPolicy, CookiePolicy } from "@/pages/LegalPages";
import { CookieBanner } from "@/components/CookieBanner";
import { ConversionListeners } from "@/components/ConversionListeners";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center">
        <Loader2 className="w-8 h-8 animate-spin text-rose-700" />
      </div>
    );
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/marcacao" element={<Booking />} />
              <Route path="/marcacao/confirmada" element={<FreeConfirmed />} />
              <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
              <Route path="/politica-de-cookies" element={<CookiePolicy />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </SmoothScroll>
          <CookieBanner />
          <ConversionListeners />
          <WhatsAppFloat />
        </BrowserRouter>
      </ContentProvider>
      <Toaster position="top-center" />
    </AuthProvider>
  );
}

export default App;
